/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyerslanguagede3Inputs */

const en_placeflyerslanguagede3 = /** @type {(inputs: Placeflyerslanguagede3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const de_placeflyerslanguagede3 = /** @type {(inputs: Placeflyerslanguagede3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

/**
* | output |
* | --- |
* | "Deutsch" |
*
* @param {Placeflyerslanguagede3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyerslanguagede3 = /** @type {((inputs?: Placeflyerslanguagede3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyerslanguagede3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyerslanguagede3(inputs)
	return de_placeflyerslanguagede3(inputs)
});
export { placeflyerslanguagede3 as "placeFlyersLanguageDe" }